// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"366": "9154912f","698": "e8a9edb5","941": "e8fdc1e3","985": "482cb750",}[chunkId] + ".css"
}